import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { useEffect, useState } from 'react';
import { useUserSettings } from "../../hooks/useUserDetails";
import { LocalStorageOnBoardingDateName } from "../../helper/constants";
import { useHistory } from "react-router-dom";
import { useUserQuestionnairesForOnboarding } from "../../hooks/useUserQuestionnaires";


export default function QuestionnaireQuestionModal() {

    const history = useHistory();
    const pathName = window.location.pathname.toLowerCase();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { data : onboardingData } = useUserQuestionnairesForOnboarding();
    
    const { data } = useUserSettings();

    const Proceed = () => {
        history.push("/user/feedbacks/onboarding");
        setIsOpen(false);
    }

    const HandleAnswerLater  = () => {
        SetToAnswerNextDay();
        setIsOpen(false);
    }

    const SetToAnswerNextDay = () => {
        // 1 Day
        let result = new Date();
        result.setDate(result.getDate() + 1);
        //Use local storage 
        window.localStorage.setItem(LocalStorageOnBoardingDateName, result.toString());
    }



    useEffect(() => {
        if(data?.me && onboardingData) {

            if(onboardingData.user_questionnaire_onboarding === null) {
                SetToAnswerNextDay();
                return;
            }
            
            const getDismissDate = window.localStorage.getItem(LocalStorageOnBoardingDateName);
            if(getDismissDate) { 
                if(new Date() < new Date(getDismissDate)) {
                  return;
                }
            } 

            if(!data.me.is_onboarded && pathName !== "/user/feedbacks/onboarding") {
                setIsOpen(true);
            }
            else if(data.me.is_onboarded)  {
                
                SetToAnswerNextDay();
            }
        }
        
    },[data, onboardingData, pathName]);

    return (
    <Modal
        isOpen={isOpen}
        backdrop={true}
    >
        <ModalHeader
            className="pb-0"
        >
            <p className="text-lg font-weight-bold">Welcome to desk.coach!</p>
        </ModalHeader>
        <ModalBody className="pt-0">
            <div>
                <small className="">
                We're so glad you're here! Before we get started, mind answering a few quick questions to help us support you better?
                </small>
                <div className="d-flex justify-content-between mb-3 mt-5">
                    
                    <Button onClick={HandleAnswerLater}>Answer Later</Button>
                    <Button onClick={Proceed} className="bg-primary text-white"  >Proceed</Button>
                </div>
            </div>
            
        </ModalBody>
    </Modal>
    )
}